import { updatedTags } from 'data/html/tags';

export const getTag = (name) => {
  const neededInfo = updatedTags?.find((tag) => tag.name === name);
  return neededInfo;
};
